import { styledPolymorphic } from '@qred/components-library';

export const CardOptInPage = styledPolymorphic<'div', {}>()((_styled) =>
  _styled(({ theme }) => ({
    width: '100%',
    height: '100%',
    overflow: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px 0',
    flexWrap: 'wrap',
    [theme.fn.largerThan('tablet')]: {
      padding: '40px 0',
    },
  }))
);

export const CardOptInContent = styledPolymorphic<'div', {}>()((_styled) =>
  _styled(({ theme }) => ({
    height: 'auto',
    width: '576px',
    justifySelf: 'center',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '20px',
    padding: '0 16px',

    [theme.fn.largerThan('tablet')]: {
      gap: '40px',
      padding: '0',
    },
  }))
);

export const ContentCard = styledPolymorphic<'div'>()((_styled) =>
  _styled(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column' as const,
    padding: '16px',
    borderRadius: '8px',
    background: theme.fn.themeColor('Container/Option_2_(White)'),
    height: 'fit-content',
    cursor: 'pointer',
    [theme.fn.largerThan('tablet')]: {
      padding: '32px 24px',
    },
  }))
);
